/*
Usage Notes: 

The following web component can be dropped into any standard Shopify theme (i.e. non-headless), using Liquid to pass product data:

  {% assign skioSellingPlanGroups = product.selling_plan_groups | where: 'app_id', 'SKIO' %}
  {% if skioSellingPlanGroups.size > 0 %}
    <skio-plan-picker 
      product='{{ product | json | escape }}'
      selectedVariant='{{ product.selected_or_first_available_variant | json | escape }}'
      formId='{{ product_form_id }}'
      currency='{{ cart.currency.iso_code }}'
      >
    </skio-plan-picker>
    <script src="{{ 'skio-plan-picker-component.js' | asset_url }}" type="module"></script>
    {% render 'skio-details' %}
  {% endif %}

  Note: formId not required if element is inside of a form already

  Example variantChanged event dispatch:
  document.dispatchEvent( new CustomEvent("variantChanged", { detail: { variantId: variant.id } }) );
*/

import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js';

const skioStyles = css`
  .skio-plan-picker {
    display: flex;
    flex-direction: column-reverse;
    gap: 10px;
    padding: 0;
    border: 0;
    margin: 20px 0;
  }
  .skio-onetime-second {
    order: 2;
  }
  
  .skio-group-container {
    display: none;
  }
  .skio-group-container--available {
    display: block;
    position: relative;
    border-radius: 5px;
    border-width: 1px;
    border-color: #E8E8E1;
    border-style: solid; 
    transition: border-color 0.2s ease, opacity 0.2s ease;
    color:#0033a1;
  }
  .skio-group-container--selected {
    border-color: #0033a1;
    opacity: 1;
  }
  
  .skio-group-input {
    position: absolute;
    width: 0px;
    height: 0px;
    opacity: 0;
  }
  .skio-group-input:focus-visible ~ .skio-group-label {
    outline: 2px #ccc solid;
    outline-offset: 4px;
    border-radius: 5px;
  }
  
  .skio-group-label {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    padding: 24px 15px;
    overflow: hidden;
  }
  
  .skio-group-topline {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    font-size: 16px;
  }
  
  .skio-radio__container {
    display: flex;
    margin-right: 10px;
  }
  
  .skio-radio {
    transition: transform 0.25s cubic-bezier(0.4,0,0.2,1), opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    transform-origin: center;
    transform: scale(0);
    opacity: 0;
  }
  .skio-group-label:hover .skio-radio {
    transform: scale(1);
    opacity: 0.75;
  }
  .skio-group-container--selected .skio-group-label .skio-radio {
    transform: scale(1);
    opacity: 1;
  }
  
  .skio-price {
    margin-left: auto;
    display: flex;
    flex-direction: column;
    align-items: end;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
  }

  .skio-recurring {

  }
  
  .skio-group-container--selected .skio-group-content {
    display: block;
  }

  .skio-group-content {
    width: auto;
    /* margin-left: 30px; */
    transition: max-height 0.25s cubic-bezier(0.4,0,0.2,1),
                opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    /* max-height: 38px; */
    opacity: 1;
    display: none;
  }

  .skio-price del {
    margin-right: 5px;
    color: rgba(11, 23, 139, 0.50);

  }
  
  /* Hide frequency if not selected */
  .skio-group-container:not(.skio-group-container--selected) .skio-group-content {
    /* max-height: 0; */
    /* opacity: 0;
    pointer-events: none; */
  }
  
  .skio-group-title {
    min-width: max-content;
    font-weight: 900;
    font-size: 15px;
    line-height: 1;
  }
  
  .skio-save {
    /* color: #0fa573;
    border: 1px #0fa573 solid; 
    padding: 0px 8px;
    border-radius: 20px; */
    color: #0033a1;
    opacity: 0.7;
    font-weight: 400;
  }
  
  .skio-frequency {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 8px 30px 8px 10px;
    margin-top: 5px;
    border-radius: 5px;
    background-color: #f7f7f7;
    width: 100%;
    border: 0;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    background-position: right 10px top 50%;
    background-size: 18px;
    background-repeat: no-repeat;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    margin: 10px 0px;
    color: #0033a1;
    /* border: 1px solid #0033a1; */
    background-color: rgba(0, 51, 161, 0.1) !important;
    max-width: 300px;
  }
  .skio-frequency.skio-frequency--one {
    background-image: none;
  }
  
  .skio-frequency span {
    text-transform: lowercase;
  }

  .skio-frequency-group {
    display: flex;
    gap: 8px;
    margin: 10px 0;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-evenly;
  }
  .skio-frequency-btn {
    padding: 8px 16px;
    border: 1px solid #E8E8E1;
    background: #fff;
    color: #0033a1;
    border-radius: 5px;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    font-size: 13px;
    font-family: inherit;
    font-weight: 500;
    width: calc(33% - 5px);
    height: 50px;
    text-transform: capitalize;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
  }
  .skio-frequency-btn.selected,
  .skio-frequency-btn:focus {
    border-color: #0B178B;
    outline: none;
  }

  .saving_badge {
    border-radius: 5px;
    background: var(--Teal, #00AEC3);
    color: var(--White, #FFF);
    text-align: center;
    font-family: "PP Right Grotesk";
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    padding: 0 4px;
    margin-left: 4px;
  }

  .most_popular_badge {
    position: absolute;
    top: -10px;
    left: 16px;
    border-radius: 5px;
    padding: 0 4px;
    background: var(--Navy, #0B178B);
    color: var(--White, #FFF);
    text-align: center;
    font-family: "PP Right Grotesk";
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
  }

  .skio-extra-info {
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: start;
    justify-content: start;
  }

  .skio-extra-info div {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 500;
  }

  .skio-extra-info svg {
    width: 20px;
    height: auto;
  }

  .skio-subscription:not(.is-show) {
    display: none
  }

`;

export class SkioPlanPickerComponent extends LitElement {
  static properties = {
    product: { type: Object },            //required
    productHandle: { type: String },      //optional (unless product isn't passed, then required)
    key: { type: String },                //optional, defaults to product.id; identifier for this instance of the Skio plan picker
    
    formId: { type: String },             //optional; if passed, used to connect input fields to form
    needsFormId: { type: Boolean },       //optional, defaults to false; if true, element needs to be passed a formId, else it searches for a form

    subscriptionFirst: { type: String }, //optional, defaults to false; if true, shows subscription option above onetime
    startSubscription: { type: String }, //optional, defaults to false; if true, auto-selects subscription on page load
    discountFormat: { type: String },     //optional, defaults to percent; can also pass "fixed"
    
    currency: { type: String },           //optional, defaults to 'USD', but can pass any 3 char identifier
    language: { type: String },           //optional, defaults to 'en-US', but can pass any similarly formatted language identifier
    moneyFormatter: {},                   //placeholder for object

    externalPriceSelector: { type: String },      //optional, used to update the external price

    externalPriceSelectorWithCurrency: { type: String },      //optional, used to update the external price
  
    selectedVariant: { type: Object },    //placeholder for data
    skioSellingPlanGroups: {},            //placeholder for data
    availableSellingPlanGroups: {},       //placeholder for data
    selectedSellingPlanGroup: {},         //placeholder for data
    selectedSellingPlan: {},              //placeholder for data

    defaultFrequency: {},                 //placeholder for data

    showOnetimeSlashed: {},

    meta: {},

    showUnitPrice: {},

    showFreeString: {},
  };

  static styles = skioStyles;

  constructor() {
    super();
    this.product = null;
    this.selectedVariant = null;

    this.productHandle = null;

    this.purchaseOption = 'onetime';

    this.key = null;
    this.formId = null;
    this.needsFormId = false;

    this.skioSellingPlanGroups = [];
    this.availableSellingPlanGroups = [];

    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;

    this.startSubscription = 'false';
    this.subscriptionFirst = 'false';

    this.skioMainProduct = true;

    this.discountFormat = 'percent';

    this.externalPriceSelector = '[skio-external-price], [id^="ProductPrice"] span';

    this.externalPriceSelectorWithCurrency = '[skio-external-price-with-currency]';

    this.currency = 'USD';
    this.language = 'en-US';
    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: 'currency',
      currency: this.currency,
    });

    this.defaultFrequency = null;

    this.showOnetimeSlashed = false;

    this.meta = {};
    this.showUnitPrice = false;
    this.showFreeString = false;
    this.stickyComparePrice = document.querySelector("[js-sticky-compare-price]")

  }

  connectedCallback() {
    super.connectedCallback();

    if (this.startSubscription == 'true') {
      this.purchaseOption = 'subscription';
    }

    if(!this.product && this.productHandle) {
      this.fetchProduct(this.productHandle);
    }

    if (this.needsFormId && this.formId == null) {
      let forms = document.querySelectorAll('form[action="/cart/add"]');
      if (forms.length > 0) {
        let form;
        forms.forEach((el) => {
          if (el.hasAttribute('skio-key')) {
            if (el.getAttribute('skio-key') == this.key) form = el;
          }
        });
        if (!form) form = forms[0];
        this.formId = form.id;
        this.requestUpdate();
      }
    }
    let skio = this;
    document.addEventListener("variantChanged", function(e) {
      //update variant id
      let variantId = e.detail.variantId;
      let variant = skio.product.variants.find(x => x.id == variantId);
      if (variant) skio.selectedVariant = variant;
      else skio.log("Unable to find variant with id: ", variantId);
      skio.requestUpdate();
    });

    //console.log("CURRENCY: ", skio.currency);

    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: 'currency',
      currency: skio.currency,
    });

    this.requestUpdate();

    if (this.meta !== '') this.meta = JSON.parse(this.meta);
    //console.log("metafields? ", this.meta);

    this.initQuantityOptions();

    // Add this setTimeout to ensure the component is fully rendered
    setTimeout(() => {
      if (this.availableSellingPlanGroups && this.availableSellingPlanGroups.length > 0) {
        // Select the last subscription group
        const lastGroup = this.availableSellingPlanGroups[this.availableSellingPlanGroups.length - 1];
        const lastGroupSelectedSellingPlan = lastGroup.selling_plans[lastGroup.selling_plans.length - 1];
        this.selectedSellingPlanGroup = lastGroup;
        this.selectedSellingPlan = lastGroupSelectedSellingPlan;
        lastGroup.selected_selling_plan = lastGroupSelectedSellingPlan;
        this.requestUpdate();
      }
    }, 500); // 500ms delay to ensure everything is loaded
  }

  initQuantityOptions() {
    const mainProduct = document.querySelector("[js-main-product-section]");
    if(mainProduct) {
      const firstOption = mainProduct.querySelector("[js-custom-option]");
      const quantityOptions = mainProduct.querySelectorAll("[js-quantity-option]");

      if(quantityOptions.length) {
        const stickyBar = document.querySelector("[js-sticky-bar]");
        const stickyBarQuantityField = stickyBar.querySelector("[js-sticky-bar-quantity-field]");
        const stickyRegularPricEl = stickyBar.querySelector("[js-sticky-regular-price]");
        const regularPriceEl = mainProduct.querySelector("[id^='ProductPrice']");
        const comparePriceEl = mainProduct.querySelector("[id^='ComparePrice']");

        setTimeout(() => {
          const skioShadowRoot = this.shadowRoot; 
          const skioSubscription = skioShadowRoot.querySelector("[js-skio-subscription]");
          const skioOneTimeOption = skioShadowRoot.querySelector("[js-one-time-option]");
          const skioSubscriptionRegularPrice = skioShadowRoot.querySelector("[skio-subscription-price]");
          const skioOneTimePrice = skioShadowRoot.querySelector("[skio-onetime-price]");
          quantityOptions.forEach(option => option.addEventListener("change", handleQuantity));

          const activeOptionEl = mainProduct.querySelector("[js-custom-option]:checked");
          activeOptionEl.dispatchEvent(new Event("change"))

          if(firstOption.hasAttribute("checked") || firstOption.classList.contains("is-checked")) {
            skioSubscription.classList.remove("is-show");
          }

          function handleQuantity() {
            const skioSubscriptionComparePrice = skioShadowRoot.querySelector("del");
            stickyBarQuantityField.value = this.value;

            if(parseInt(this.getAttribute("data-index")) === 1) {
              skioOneTimeOption.click();
              setTimeout(function() {
                skioSubscription.classList.remove("is-show");
              })
            }else {
              skioSubscription.classList.add("is-show")
            }
        
            regularPriceEl.innerHTML = `<span class="money">${this.getAttribute("data-regular-price")}</span>`;
            skioOneTimePrice ? skioOneTimePrice.textContent = this.getAttribute("data-regular-price") : null;
            skioSubscriptionRegularPrice ? skioSubscriptionRegularPrice.textContent = this.getAttribute("data-subscription-regular-price") : null;

            if(skioSubscriptionComparePrice) {
              skioSubscriptionComparePrice.textContent = this.getAttribute("data-subscription-compare-price");
            }else {
              skioSubscriptionRegularPrice.insertAdjacentHTML("beforebegin", `<del>${this.getAttribute("data-subscription-compare-price")}</del>`)
            };

            comparePriceEl ? comparePriceEl.innerHTML = `<span class="money">${this.getAttribute("data-compare-price")}</span>` : null;
            stickyRegularPricEl.textContent = this.getAttribute("data-regular-price");
          }
        }, 200)
      };
    }
  }

  render() {
    if(!this.product || !this.selectedVariant || this.skioSellingPlanGroups.length == 0) return;
    
    return html`
      <fieldset class="skio-plan-picker" skio-plan-picker="${ this.key }">
        <input ${ this.formId !== null ? html`form="${ this.formId }"` : '' } name="selling_plan" type="hidden" value="${ this.selectedSellingPlan !== null ? this.selectedSellingPlan?.id : ''}" />
        <input ${ this.formId !== null ? html`form="${ this.formId }"` : '' } name="properties[Discount]" type="hidden" value="${ this.selectedSellingPlan !== null ? this.discount(this.selectedSellingPlan).percent : '' }" 
          ?disabled="${ this.selectedSellingPlan == null ? true : false }" />
        
        <div class="skio-group-container ${ this.product.requires_selling_plan == false ? 'skio-group-container--available' : '' } ${ this.selectedSellingPlanGroup == null ? 'skio-group-container--selected' : '' } ${ this.subscriptionFirst == 'true' ? 'skio-onetime-second' : ''}" skio-group-container 
          @click=${() => this.selectSellingPlanGroup(null) } >
        
          <input id="skio-one-time-${ this.key }" class="skio-group-input" name="skio-group-${ this.key }" type="radio" value="" 
            skio-one-time ?checked=${ this.startSubscription == 'false' && this.product.requires_selling_plan == false ? true : false }>
          <label class="skio-group-label" for="skio-one-time-${ this.key }" js-one-time-option>
            <div class="skio-group-topline">
              <div class="skio-radio__container">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
                  <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
                </svg>
              </div>
              <div class="skio-group-title">
                One-time purchase
              </div>
              <div class="skio-price">
                <div>
                  <span skio-onetime-price>${ this.moneyFormatter.format(this.selectedVariant.price / 100) }</span>
                  ${ this.showUnitPrice && this.getMetadata(this.selectedVariant.id, 'units') && this.getMetadata(this.selectedVariant.id, 'unitType') ? html`
                    <span>(${ this.money((this.selectedVariant.price) / this.getMetadata(this.selectedVariant.id, 'units')) } / ${ this.getMetadata(this.selectedVariant.id, 'unitType') })</span>
                  ` : html``}
                </div>
              </div>
            </div>
          </label>
        </div>
        ${ this.availableSellingPlanGroups ? this.availableSellingPlanGroups.map((group, index) => 
          html`
            <div class="skio-group-container skio-group-container--available skio-subscription is-show ${ this.selectedSellingPlanGroup == group ? 'skio-group-container--selected' : '' }" skio-group-container
              @click=${() => this.selectSellingPlanGroup(group) } js-skio-subscription>
              <input id="skio-selling-plan-group-${ index }-${ this.key }" class="skio-group-input" name="skio-group-${ this.key }"
                type="radio" value="${ group.id }" skio-selling-plan-group="${ group.id }" ?checked=${ this.selectedSellingPlanGroup == group ? true : false } >
              <label class="skio-group-label" for="skio-selling-plan-group-${ index }-${ this.key }">
                <div class="skio-group-topline">
                  <div class="skio-radio__container">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
                      <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
                    </svg>
                  </div>
                  <div class="skio-group-title">
                    ${ group.name == 'Subscription' ? 'Subscribe & save' : group.name }
                  </div>
                  <div class="skio-price">
                    <div>
                      ${ this.showOnetimeSlashed && this.moneyFormatter.format(this.selectedVariant.price / 100) !== this.price(group.selected_selling_plan) ? html`
                        <del>${ this.moneyFormatter.format(this.selectedVariant.price / 100) }</del>
                      ` : html``}
                      <span skio-subscription-price>${ this.price(group.selected_selling_plan) }</span>
                      ${ this.showUnitPrice && this.getMetadata(this.selectedVariant.id, 'units') && this.getMetadata(this.selectedVariant.id, 'unitType') ? html`
                        <span>(${ this.money((this.selectedVariant.price - this.discount(group.selected_selling_plan).amount) / this.getMetadata(this.selectedVariant.id, 'units')) } / ${ this.getMetadata(this.selectedVariant.id, 'unitType') })</span>
                      ` : html``}
                      ${ this.showFreeString && this.getMetadata(this.selectedVariant.id, 'freeText') ? html`
                        <span>(${ this.getMetadata(this.selectedVariant.id, 'freeText') })</span>
                      ` : html``}
                    </div>
                    ${ this.getPriceAdjustmentForSelectedSellingPlan(group) ? html`
                      <div class="skio-recurring">then ${ this.getPriceAdjustmentForSelectedSellingPlan(group) } recurring</div>
                    ` : html`` }
                  </div>

                </div>
                <div class="skio-group-content">
                  <div class="skio-frequency-group">
                    ${group ? group.selling_plans.map((selling_plan) => html`
                      <button
                        type="button"
                        class="skio-frequency-btn${group.selected_selling_plan == selling_plan ? ' selected' : ''}"
                        @click=${() => {
                          group.selected_selling_plan = selling_plan;
                          this.selectedSellingPlanGroup = group;
                          this.selectedSellingPlan = selling_plan;
                        }}
                      >
                        ${(() => {
                          let name = selling_plan.name.toLowerCase();
                          return group.name == 'Subscription'
                            ? name.replace('every', '').trim()
                            : selling_plan.name.replace(/every/gi, '').trim();
                        })()}

                        <div class="saving_badge">${this.discount(group.selected_selling_plan).percent == '0%' ? '' : 'save ' + this.discount(group.selected_selling_plan).percent}</div>
                      </button>
                    `) : ''}
                  </div>

                  <div class="skio-extra-info">
                    
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 1024 1024" class="icon">
                        <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z"/>
                      </svg>
                      <span>
                        Free shipping always
                      </span>
                    </div>

                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                        <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                      </svg>
                      <span>
                        Flexible: cancel, skip, or change anytime
                      </span>
                    </div>

                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bell" viewBox="0 0 16 16">
                        <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z"/>
                      </svg>
                      <span>
                        Reminder 3 days before your next order
                      </span>
                    </div>

                  </div>

                </div>
              </label>
              <div class="most_popular_badge">Most Popular</div>
            </div>
          `
        ): ''}
      </fieldset>`
  }

  updated = (changed) => {

    if(changed.has('product') && this.product) {

      //update key

      this.key = this.key ? this.key : this.product.id;



      //update skioSellingPlanGroups

      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(

        selling_plan_group => selling_plan_group.app_id === 'SKIO'

      )



      this.skioSellingPlanGroups.forEach((group) => {

        group.selling_plans.sort(function(a,b){

          if (parseInt(a.name.replace(/\D/g, "")) < parseInt(b.name.replace(/\D/g, ""))) return -1;

          if (parseInt(a.name.replace(/\D/g, "")) > parseInt(b.name.replace(/\D/g, ""))) return 1;

          if (parseInt(a.name.replace(/\D/g, "")) == parseInt(b.name.replace(/\D/g, ""))) return 0;

        })

      });



    }



    if(changed.has('selectedVariant') && this.selectedVariant) {

      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id

      let skioSellingPlanGroups = JSON.parse(JSON.stringify(this.skioSellingPlanGroups));

      this.availableSellingPlanGroups = skioSellingPlanGroups.filter(selling_plan_group =>

        selling_plan_group.selling_plans.some(selling_plan =>

          this.selectedVariant.selling_plan_allocations.some(

            selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id

          )

        )

      )



      //update selectedSellingPlan value

      if (this.availableSellingPlanGroups?.length > 0) {

        //update each group with a default selected_selling_plan



        this.availableSellingPlanGroups.forEach((group) => {

          group.selling_plans = group.selling_plans.filter(x => this.selectedVariant.selling_plan_allocations.find(y => y.selling_plan_id == x.id) );

        })



        this.availableSellingPlanGroups.forEach((group => {

          if (this.defaultFrequency) {

            let selling_plan = group.selling_plans.find(x => x.name.toLowerCase().includes(this.defaultFrequency.toLowerCase()));

            if (selling_plan) group.selected_selling_plan = selling_plan;

            else group.selected_selling_plan = group.selling_plans[0];

          } else {

            group.selected_selling_plan = group.selling_plans[0];

          }

       }));



        if (this.startSubscription == true || this.product.requires_selling_plan == true || this.purchaseOption == 'subscription') {

          //find a matching selling plan, or choose first available



          if (this.selectedSellingPlan == null || this.selectedSellingPlan == undefined) {

            this.selectSellingPlanGroup(this.availableSellingPlanGroups[0]);

          }



          let sellingPlanName = this.selectedSellingPlan?.name;



          let sellingPlanGroup = this.availableSellingPlanGroups.find(x => x.selling_plans.find(y => y.name == sellingPlanName));

          let sellingPlan = sellingPlanGroup?.selling_plans.find(y => y.name == sellingPlanName);

          if (sellingPlanName == sellingPlan?.name) {

            this.selectedSellingPlanGroup = sellingPlanGroup;

            this.selectedSellingPlan = sellingPlan;

          } else {

          this.selectedSellingPlanGroup = this.availableSellingPlanGroups[0];

          this.selectedSellingPlan = this.availableSellingPlanGroups[0].selling_plans[0];

          }



        } else {

          this.selectedSellingPlan, this.selectedSellingPlanGroup = null

        }

      } else {

        this.selectedSellingPlan, this.selectedSellingPlanGroup = null

      }



      //update the form that was passed, if any

      this.updateForm();



    }



    if(changed.has('selectedSellingPlan')) {

      //update price of price elements if applicable

      document.querySelectorAll(`[skio-price][skio-key="${ this.key }"]`).forEach((el) => {

        el.innerHTML = this.price(this.selectedSellingPlan);

      });



      //update display of external content elements

      document.querySelectorAll(`[skio-onetime-content][skio-key="${ this.key }"]`).forEach((el) => {

        this.selectedSellingPlan !== null ? el.style.display = "none" : el.style.removeProperty('display');

      });



      document.querySelectorAll(`[skio-subscription-content][skio-key="${ this.key }"]`).forEach((el) => {

        this.selectedSellingPlan == null ? el.style.display = "none" : el.style.removeProperty('display');

      });



      //dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan

      const event = new CustomEvent(`skio::update-selling-plan`, {

        bubbles: true, 

        composed: true, 

        detail: {

          sellingPlan: this.selectedSellingPlan,

          key: this.key

        }

      });



      this.dispatchEvent(event);



      //update the form that was passed, if any

      this.updateForm();

      this.updateExternalPrice();

      if(document.querySelector("[js-custom-option]")) {
        this.updateQTProductPrice();
      }



    }



    if(changed.has('formId')) {

      //update the form that was passed, if any

      this.updateForm();

    }



  }

  log = (...args) => {
    args.unshift('%c[skio]', 'color: #8770f2;');
    console.log.apply(console, args);
  }

  error = (...args) =>  {
    args.unshift('%c [skio]', 'color: #ff0000');
    console.error.apply(console, args);
  }

  updateExternalPrice() {
    document.querySelectorAll(this.externalPriceSelector).forEach((el) => {
      el.innerHTML = this.price(this.selectedSellingPlan);
    })
    document.querySelectorAll(this.externalPriceSelectorWithCurrency).forEach((el) => {
      el.innerHTML = this.price(this.selectedSellingPlan) + ' ' + this.currency;
    })

    if(this.stickyComparePrice) {
      if(this.purchaseOption === 'subscription') {
        this.stickyComparePrice.innerHTML = this.money(this.selectedVariant.price);
        this.stickyComparePrice.classList.remove("hide");
      }else {
        if(this.selectedVariant.compare_at_price > this.selectedVariant.price) {
          this.stickyComparePrice.innerHTML = this.money(this.selectedVariant.compare_at_price);
          this.stickyComparePrice.classList.remove("hide");
        }else {
          this.stickyComparePrice.innerHTML = "";
          this.stickyComparePrice.classList.add("hide");
        }
      }
    }
  }

  updateQTProductPrice() {
    const stickyRegularPricEl = document.querySelector("[js-sticky-regular-price]");
    const regularPriceEl = document.querySelector("[id^='ProductPrice']");
    const comparePriceEl = document.querySelector("[id^='ComparePrice']");
    const activeOption = document.querySelector("[js-custom-option]:checked");

    if(!activeOption) return;

    if(this.purchaseOption === 'subscription') {
      const skioSubscriptionRegularPrice = activeOption.getAttribute("data-subscription-regular-price");
      const skioSubscriptionComparePrice = activeOption.getAttribute("data-subscription-compare-price");

      regularPriceEl.innerHTML = `<span class="money">${skioSubscriptionRegularPrice}</span>`;
      stickyRegularPricEl.textContent = skioSubscriptionRegularPrice;
      comparePriceEl ? comparePriceEl.innerHTML = `<span class="money">${skioSubscriptionComparePrice}</span>` : null;
    }else {
      const regularPrice = activeOption.getAttribute("data-regular-price");
      const comparePrice = activeOption.getAttribute("data-compare-price");

      regularPriceEl.innerHTML = `<span class="money">${regularPrice}</span>`;
      stickyRegularPricEl.textContent = regularPrice;
      comparePriceEl ? comparePriceEl.innerHTML = `<span class="money">${comparePrice}</span>` : null;
    }
  }

  getMetadata(variantId, field) {
    let meta = this.meta;
    if (meta !== {}){
      let variantData = meta[variantId];
      if (variantData) {
        let fieldData = variantData[field];
        if (fieldData) return fieldData;
        else return '';
      }
    }
  }

  getPriceAdjustments() {

    let selling_plan_allocations = this.selectedVariant.selling_plan_allocations;
    //console.log("selling plan allocations: ", selling_plan_allocations);

    selling_plan_allocations.forEach((allocation) => {
      let adjustments = allocation.price_adjustments;
      //console.log("adjustments: ", adjustments);
    })

  }

  getPriceAdjustmentForSelectedSellingPlan(group) {
    let sellingPlan = group.selected_selling_plan;
    let selling_plan_allocation = this.selectedVariant.selling_plan_allocations.find(x => x.selling_plan_id == sellingPlan.id);
    //console.log("current selling plan allocation: ", selling_plan_allocation);
    let price_adjustments = selling_plan_allocation?.price_adjustments;
    if (price_adjustments) {
      if (price_adjustments.length > 1) {
        let price = this.money(price_adjustments[1]['price'])
        return price;
      } else {
        return false;
      }
    } else {
      return false;
    }
    
  }
  
  // Update selected selling plan group; called on click of skio-group-container element
  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group;
    this.selectedSellingPlan = group?.selected_selling_plan;
    if (group) this.purchaseOption = 'subscription'
    else this.purchaseOption = 'onetime'

    //update the form that was passed, if any
    this.updateForm();
  }

  // Formats integer value into money value
  money(price) {
    return this.moneyFormatter.format(price / 100.0)
  }

  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discount(selling_plan) {

    if (!selling_plan)
      return { percent: '0%', amount: 0 }

    if (selling_plan?.name?.includes('prepaid')) {

      let option = selling_plan.options[0]['value'];

      var numberPattern = /\d+/g;
      let result = parseInt(option.match( numberPattern ).join(''));

      const price_adjustment = selling_plan.price_adjustments[0]
      const discount = { percent: '0%', amount: 0 }
      const price = this.selectedVariant.price * result;
      
      switch (price_adjustment.value_type) {
        case 'percentage':
          discount.percent = `${price_adjustment.value}%`
          discount.amount = Math.round(
            (price * price_adjustment.value) / 100.0
          )
          break
        case 'fixed_amount':
          discount.percent = `${Math.round(
            ((price_adjustment.value * 1.0) / price) * 100.0
          )}%`
          discount.amount = price - price_adjustment.value
          break
        case 'price':
          discount.percent = `${Math.round(
            (((price - price_adjustment.value) * 1.0) /
              price) *
              100.0
          )}%`
          discount.amount = price - price_adjustment.value
          break
      }
      
      return discount

    } else {

      const price_adjustment = selling_plan.price_adjustments[0]
      const discount = { percent: '0%', amount: 0 }
      const price = this.selectedVariant.price;
      
      switch (price_adjustment.value_type) {
        case 'percentage':
          discount.percent = `${price_adjustment.value}%`
          discount.amount = Math.round(
            (price * price_adjustment.value) / 100.0
          )
          break
        case 'fixed_amount':
          discount.percent = `${Math.round(
            ((price_adjustment.value * 1.0) / price) * 100.0
          )}%`
          discount.amount = price_adjustment.value
          break
        case 'price':
          discount.percent = `${Math.round(
            (((price - price_adjustment.value) * 1.0) /
              price) *
              100.0
          )}%`
          discount.amount = price - price_adjustment.value
          break
      }
      
      return discount

    }
    
  }

  // Calculates the variant's price for the given selling plan, returns a formatted money value (if desired)
  price(selling_plan, formatted = true) {

    if (selling_plan?.name?.includes('prepaid')) {

      let option = selling_plan.options[0]['value'];
      var numberPattern = /\d+/g;
      let result = parseInt(option.match( numberPattern ).join(''));

      return formatted
        ? this.money( (this.selectedVariant.price * result) - this.discount(selling_plan).amount)
        :  (this.selectedVariant.price * result) - this.discount(selling_plan).amount

    } else {

      return formatted
        ? this.money( this.selectedVariant.price - this.discount(selling_plan).amount)
        :  this.selectedVariant.price - this.discount(selling_plan).amount

    }

    
  }

  // If a formId was passed, appends the necessary <input> elements to the form
  updateForm() {
    if (this.formId) {
      let mainProductForm = document.querySelector(`#${this.formId}`);
      let stickyProductForm = document.querySelector("[js-product-sticky-form]");

      this.productForm(mainProductForm);
      this.productForm(stickyProductForm);
    }
  }

  productForm(form) {
    if (form) {
      let selling_plan_input = form.querySelector('[name="selling_plan"]');
      if (selling_plan_input) {
        selling_plan_input.value = this.selectedSellingPlan?.id !== undefined ? this.selectedSellingPlan?.id : null;
        selling_plan_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
      } else {
        selling_plan_input = document.createElement('input');
        selling_plan_input.type = "hidden";
        selling_plan_input.name = "selling_plan";
        selling_plan_input.value = this.selectedSellingPlan?.id !== undefined ? this.selectedSellingPlan?.id : null;
        selling_plan_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
        form.append(selling_plan_input);
      }

      let discount_input = form.querySelector('[name="properties[Discount]"]');
      if (discount_input) {
        discount_input.value = this.selectedSellingPlan?.id !== undefined ? this.discount(this.selectedSellingPlan).percent : null;
        discount_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
      } else {
        discount_input = document.createElement('input');
        discount_input.type = "hidden";
        discount_input.name = "properties[Discount]";
        discount_input.value = this.selectedSellingPlan?.id !== undefined ? this.discount(this.selectedSellingPlan).percent : null;
        discount_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
        form.append(discount_input);
      }

      if(document.querySelector("[js-main-product-section]")?.classList.contains("has-quantity-options")) {
        discount_input.disabled = true;
      }

    } else {
      console.log(`Skio error: form ID is ${ this.formId }, but no form with that ID was found.`);
    }
  }

  // Optional functions keep if necessary 

  /**
   *   
   * 
   */
  
  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart(quantity) {
    const items = [
      {
        id: this.selectedVariant.id,
        quantity: quantity,
        ...(this.selectedSellingPlan && { selling_plan: this.selectedSellingPlan?.id })
      }
    ];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
    .then((response) => response.json())
    .then((response) => {
      this.log("SKIO added item to cart: ", response);
      //dispatch CustomEvent to tell document that an item was added to cart
      const event = new CustomEvent(`skio::added-to-cart`, {
        bubbles: true, 
        composed: true, 
        detail: {
          response,
          key: this.key
        }
      });

      this.dispatchEvent(event);
    })
    .catch((error) => {
      this.error(`SKIO ${ this.key } error adding item to cart: `, error);
    });
  } 

  fetchProduct = (handle) => {
    return fetch(`/products/${ handle }.js`)
    .then((response) => response.json())
    .then((product) => {
      this.product = product;
      this.selectedVariant = product.variants[0];

      return product;
    });
  }
}

customElements.define('skio-plan-picker', SkioPlanPickerComponent);